export var Experiment;
(function (Experiment) {
    Experiment["CollapsedProductFeatures"] = "SF013-collapsed-product-features";
    Experiment["PaymentsInCartTray"] = "PLC-payment-tray";
    Experiment["PTRConfigurator"] = "ptr-product-configurator";
})(Experiment || (Experiment = {}));
export var ExperimentCommonGroups;
(function (ExperimentCommonGroups) {
    ExperimentCommonGroups["NoEnrolment"] = "";
    ExperimentCommonGroups["Control"] = "control";
    ExperimentCommonGroups["Variant"] = "variant";
})(ExperimentCommonGroups || (ExperimentCommonGroups = {}));
export var ExperimentPaymentsInCartTrayGroups;
(function (ExperimentPaymentsInCartTrayGroups) {
    ExperimentPaymentsInCartTrayGroups["PaymentsAndCheckoutVariant"] = "variant";
    ExperimentPaymentsInCartTrayGroups["PaymentsOnlyVariant"] = "variant2";
})(ExperimentPaymentsInCartTrayGroups || (ExperimentPaymentsInCartTrayGroups = {}));
